export default "/_next/static/chunks/fonts/Montserrat-Italic-latin-c39353bc85ffb0d271db376388dee4ef.woff2";